import React, {Component, Fragment} from 'react';
import styles from './BuySection.scss';
import classNames from 'classnames/bind';
import {observable, action} from 'mobx'
import {observer} from 'mobx-react'
import {
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaFacebook,
  FaWrench,
  FaHistory
} from 'react-icons/fa'
import {SocialLink} from '../../atoms';
import {SpecsModal} from '../../organisms';
import blogIcon from 'assets/images/shared/blog-icon.svg';

const cx = classNames.bind(styles);

class BuySectionStore {
  @observable modalShow = false;

  @action showModal = () => this.modalShow = true;
  @action hideModal = () => this.modalShow = false;
  @action toggleModal = () => this.modalShow = !this.modalShow;
}

const buySectionStore = new BuySectionStore();

@observer
class BuySection extends Component {
  render() {
    return (
      <Fragment>
        <section className={cx('buy')}>
          <div className={cx('buy-content')}>
            <a
              className={cx('big-buy-btn')}
              href={process.env.REACT_APP_BUY_AMAZON}
              target='_blank'
              rel='noopener noreferrer'
            >
              <span lang='en-regular'>Amazon.jp</span>で購入する
            </a>
            <div className={cx('buy-perks')}>
            <span>
              <span className={cx('buy-perks__icon')}><FaHistory /></span>
              <span className={cx('buy-perks__return')} lang='en-thin'>30 Day Return</span>
            </span>
              <span>
              <span className={cx('buy-perks__icon')}><FaWrench /></span>
              1年保証
            </span>
              <span className={cx('buy-perks__specs')}><a onClick={() => buySectionStore.showModal()}>仕様</a></span>
              <span className={cx('buy-perks__user-manual')}><a href={process.env.REACT_APP_USER_MANUAL} target='_blank' rel='noopener noreferrer'>取扱説明書</a></span>
            </div>
            <small className={cx('bulk-orders')}>
              大量注文をご希望の方は<a lang='en-thin' className={cx('bulk-orders__email')} href={process.env.REACT_APP_AWAIR_EMAIL}>hello@getawair.com</a>までご連絡ください。
            </small>
            <div className={cx('social-group')}>
              <SocialLink
                link={process.env.REACT_APP_SOCIAL_INSTAGRAM}
                icon={<FaInstagram size={32} />}
              />
              <SocialLink
                link={process.env.REACT_APP_SOCIAL_BLOG}
                icon={<img src={blogIcon} alt='blog' />}
              />
              <SocialLink
                link={process.env.REACT_APP_SOCIAL_TWITTER}
                icon={<FaTwitter size={32} />}
              />
              <SocialLink
                link={process.env.REACT_APP_SOCIAL_YOUTUBE}
                icon={<FaYoutube size={32} />}
              />
              <SocialLink
                link={process.env.REACT_APP_SOCIAL_FACEBOOK}
                icon={<FaFacebook size={32} />}
              />
            </div>
          </div>
        </section>
        <SpecsModal
          modalShow={buySectionStore.modalShow}
          onHide={buySectionStore.hideModal}
          onToggle={buySectionStore.toggleModal}
        />
      </Fragment>
    );
  }
}

export default BuySection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/BuySection/BuySection.js